import React from "react";

import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import MessageList from "./components/MessageList";

const Root = withStyles(Grid, {
  root: {
    paddingTop: 2,
    paddingLeft: 2,
    height: "100%",
  },
});

const Surface = withStyles(Paper, {
  root: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 0,
    height: "100%",
  },
});

const Title = withStyles(Typography, {
  root: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 1,
    color: colors.dark,
  },
});

const Separator = withStyles(Divider, {
  root: {
    color: "#EDF0F5",
  },
});

const FullGrid = withStyles(Grid, {
  root: {
    height: "100%",
  },
});

const MessageListPage: React.FC = () => {
  return (
    <Root container alignItems="stretch">
      <FullGrid item xs={3}>
        <Surface elevation={0}>
          <Box padding={4}>
            <Title>Messages</Title>
          </Box>
          <Separator />
          <Box flex={1} display="flex" flexDirection="column" minHeight={0}>
            <MessageList />
          </Box>
        </Surface>
      </FullGrid>
      <FullGrid item xs={9}>
        <Outlet />
      </FullGrid>
    </Root>
  );
};

export default MessageListPage;
